import gql from 'graphql-tag';

const ClaimWithDocuments = gql`
  query Claim($id: ID!, $filter: DocumentFilter) {
    claim(id: $id) {
      id
      passengerTicketId
      passengerTicket {
        id
        passengerFirstName
        passengerLastName
      }
      legalFormalNotice {
        documentsConnection {
          edges {
            node {
              id
            }
          }
        }
      }
      flight {
        id
        number
        localDepartureDate
        localArrivalDate
        airlineCode
        airline {
          name
          iata
        }
        airportOrigin {
          name
          iata
        }
        airportDestination {
          name
          iata
        }
      }
      claimsPassengerTicketConnection {
        edges {
          node {
            id
            documentsConnection(filter: $filter) {
              edges {
                cursor
                node {
                  documentId
                  id
                  attachmentContentType
                  documentUrl
                  status
                  conflictsWithClaim
                  type
                  attachmentFileName
                  formAttributes
                  documentValid
                  claimsPassengerTicket {
                    id
                    passengerTicket {
                      id
                      passengerFirstName
                      passengerLastName
                    }
                  }
                }
              }
            }
            passengerTicket {
              id
              passengerFirstName
              passengerLastName
            }
          }
        }
      }
    }
  }
`;

export { ClaimWithDocuments };



// WEBPACK FOOTER //
// ./src/queries/ClaimWithDocuments.js